import { EnvironmentType } from "waapi/environments-repository/constants/environments.js";
import { getMystiqueHostsToChromeExtensionIdMap } from "waapi/environments-repository/helpers/getExtensionIds.js";
import { getMystiqueHostsToEnvironmentNameMap } from "waapi/environments-repository/helpers/getMystiqueEnvironmentHosts.js";
import { getStargateHostsToEnvironmentNameMap } from "waapi/environments-repository/helpers/getStargateEnvironments.js";

export {
    MystiqueEnvironmentHost as EnvironmentHost,
    StargateEnvironmentHost as EnvironmentHostStargate,
    EnvironmentName,
    LocalEnvironmentName,
} from "waapi/environments-repository/constants/environments.js";
export type { AllEnvironmentName } from "waapi/environments-repository/constants/environments.js";

const environmentType = process.env.VITE_CLIENT_ENV === "production" ? EnvironmentType.PROD : EnvironmentType.STAGING;
export const isProduction = environmentType === EnvironmentType.PROD;

export const ENVIRONMENT_HOSTS = getMystiqueHostsToEnvironmentNameMap({
    environmentType,
});

export const ENVIRONMENT_HOSTS_STARGATE = getStargateHostsToEnvironmentNameMap({
    environmentType,
});

export const CHROME_EXTENSION_IDS = getMystiqueHostsToChromeExtensionIdMap({
    environmentType,
});

export const CHROME_EXTENSION_URL = "https://chrome.google.com/webstore/detail/waalaxy-ex-prospectin-pro/hlkiignknimkfafapmgpbnbnmkajgljh";

export const MINIMAL_VERSION = "1.3.223";

export const DEFAULT_PAGE = 1;
export const DEFAULT_ITEMS_PER_PAGE = 100;
export const DEFAULT_ITEMS_PER_PAGE_OPTIONS = [10, 25, 50, 100];
export const DEFAULT_CAMPAIGN_STATUS = "running" as const;

export const CAMPAIGN_FETCHING_SIZE = 25 as const;
export const CAMPAIGN_BULKBAR_FETCHING_SIZE = 30 as const;
export const CAMPAIGN_ACTION_FILTER_FETCHING_SIZE = 10 as const;
export const CAMPAIGN_DROPDOWN_NAME_MAX_LENGTH = 32 as const;
export const TRAVELER_FETCHING_SIZE = 20 as const;

export const MAX_NUMBER_OF_SEAT_COMPANY = 150;

export const ACTIONS_TYPE_GOAL = {
    LINKEDIN: "linkedin",
    EMAIL: "mail",
} as const;

export const CAMPAIGN_STATES = ["running", "paused", "draft", "stopped"] as const;

export const ADD_PROSPECTS_INPUT_TABS = {
    prospects: {
        label: "Prospects",
        value: "prospects",
    },
    triggers: {
        label: "Auto Import",
        value: "triggers",
    },
} as const;

export const MAX_PROSPECT_LIST_NAME_LENGTH = 100;
